export const LAYER_NORM_NONE = 'None';

/** Sentinel stored on a layer when the user set individual photometric targets. */
export const LAYER_NORM_CUSTOM = 'Custom';

export const NORMS = [
  'C0',
  'C1',
  'C2',
  'C3',
  'C4',
  'C5',
  'HS1',
  'HS2',
  'HS3',
  'M1',
  'M2',
  'M3',
  'M4',
  'M5',
  'M6',
  'P1',
  'P2',
  'P3',
  'P4',
  'P5',
  'P6',
  'None',
];
